import mixins from 'vue-typed-mixins';

import StudyWorkMixin from '@/user/mixins/StudyWorkMixin';

import UserWindowSizeUtility from '@/classes/common/UserWindowSizeUtility';



export default mixins(StudyWorkMixin).extend({

  name: 'StudyCalcWorkMixin',

  methods: {
    drawImage(image: HTMLImageElement, left: number, top: number): void {
      left = UserWindowSizeUtility.calculateRatio(left);
      top  = UserWindowSizeUtility.calculateRatio(top);
      const width  = UserWindowSizeUtility.calculateRatio(image.width / 2);
      const height = UserWindowSizeUtility.calculateRatio(image.height / 2);
      this.canvasContext.drawImage(image, left, top, width, height);

      // TODO:テスト終了時問題なければ消す！angular版の処理。要確認。
      // // EdgeでSVGの初回描画時にSVG内のimageがずれることがあるので再描画する
      // if (navigator.userAgent.toLocaleLowerCase().indexOf('edge') !== -1) {
      //   this._context.clearRect(left, top, width, height);
      //   this._context.drawImage(image, left, top, width, height);
      // }
    },
    drawText(str: string, left: number, top: number): void {
      left = UserWindowSizeUtility.calculateRatio(left);
      top  = UserWindowSizeUtility.calculateRatio(top);
      this.canvasContext.fillText(str, left, top);
    },
    drawLine(startX: number, startY: number, stopX: number, stopY: number): void {
      startX = UserWindowSizeUtility.calculateRatio(startX);
      startY = UserWindowSizeUtility.calculateRatio(startY);
      stopX  = UserWindowSizeUtility.calculateRatio(stopX);
      stopY  = UserWindowSizeUtility.calculateRatio(stopY);
      this.canvasContext.beginPath();
      this.canvasContext.moveTo(startX, startY);
      this.canvasContext.lineTo(stopX, stopY);
      this.canvasContext.stroke();
      this.canvasContext.closePath();
    }
  }

});
